<template>
  <div class="cell" >
    <div class="left">{{leftText}}</div>
    <img class="img" :src="imgUrl"/>
    <div class="middle">{{middleText}}</div>
    <div class="right">{{rightText}}</div>
  </div>
</template>

<script>
export default {
  props: {
    leftText: {
      type: String,
      required: true
    },
    imgUrl: {
      type: String
    },
    middleText: {
      type: String
    },
    rightText: {
      type: String
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'

.cell
  height pt(190)
  display flex
  justify-content flex-start
  align-items center
  width 100%
  font-size $normal-font-size
  border-bottom 1px solid $divide-line-color
  padding 0 pt(95) 0 pt(36)
  .left
    width 2.3em
    flex 0 0 auto
    text-align left
    color $primary-color
    margin-right pt(25)
  .img
    flex 0 0 auto
    width pt(116)
    height pt(116)
  .middle
    color $hightlint-text-color
    flex 1 1 auto
    padding-left 1em
    single-line()
  .right
    flex 0 0 auto
    text-align right
    color $normal-text-color
</style>




// WEBPACK FOOTER //
// item-statics-dish.vue?78554938